import { render, staticRenderFns } from "./BooleanWithLableDesc.vue?vue&type=template&id=2ab5fa6a&scoped=true&"
import script from "./BooleanWithLableDesc.vue?vue&type=script&lang=js&"
export * from "./BooleanWithLableDesc.vue?vue&type=script&lang=js&"
import style0 from "./BooleanWithLableDesc.vue?vue&type=style&index=0&id=2ab5fa6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5fa6a",
  null
  
)

export default component.exports